import React from 'react';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import EventDetails from './event-details';
import { SimpleLoadingComponent } from '../../utils/apollo';
import './styles.css';

class EventVisitDetailsComponent extends React.PureComponent {
  static propTypes = {
    node: PropTypes.object,
    viewer: PropTypes.object,
    appointmentId: PropTypes.string.isRequired,
  };

  render() {
    const { node: highSchool } = this.props;
    const eventDetails = {
      contact: get(highSchool, 'repVisitsAccount.primaryContact'),
      phone: get(highSchool, 'repVisitsAccount.primaryContactPhone'),
      instructions: get(highSchool, 'repVisitsAccount.webInstructions'),
      title: get(highSchool, 'name'),
    };
    return (
      <div styleName="event-details">
        <EventDetails type="visit" highSchool={highSchool} eventDetails={eventDetails} />
      </div>
    );
  }
}

export const EventVisitDetails = injectIntl(EventVisitDetailsComponent);

const query = gql`
  query EventVisitAgendaDetails($id: ID!) {
    node(id: $id) {
      id
      ... on HighSchool {
        name
        address {
          field_hs_elna_address_line1
          field_hs_elna_state_latest
          field_hs_elna_city
          field_hs_eln_zip
        }
        repVisitsAccount {
          id
          webInstructions
          primaryContactPhone
          primaryContact {
            id
            name
            field_job_position
            field_contact_work
            field_profile_picture_file_url
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id }) => ({
    variables: {
      id,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(EventVisitDetails);
